<fui-edit-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture>
            <fui-input-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                             [title]="label" [valued]="valued"></fui-input-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        @if (!disabled) {
            <fui-fixture>
                <fui-icon [height]="12" [icon]="'clock'" [width]="12"
                          [clickable]="true" (click)="toggle($event)"></fui-icon>
            </fui-fixture>
        }
        <fui-spanning-fixture>
            <fui-input-dom>
                <kendo-dateinput #input [(ngModel)]="value" (focus)="onFocus($event)" (blur)="onBlur($event)"
                                 [format]="'h:mm a'" [disabled]="disabled" [tabindex]="tabindex" [clearButton]="true"></kendo-dateinput>
            </fui-input-dom>
        </fui-spanning-fixture>
        @if (notation) {
            <fui-fixture>
                <fui-notation [title]="notation"></fui-notation>
            </fui-fixture>
        }
        @if (validateable) {
            <fui-fixture>
                <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
            </fui-fixture>
        }
    </fui-fixtures>
</fui-edit-fascia>
<fui-time-pop [popped]="popped" (popped$)="pop($event)" (click)="popClicked($event)">
    @if (popped) {
        <fui-time-selector #selector [(value)]="value" (valueChange)="selectorChanged($event)"></fui-time-selector>
    }
</fui-time-pop>
